import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { BOOK_STATUSES } from "@/lib/books";

const fieldStyle = { borderColor: "rgba(11,27,61,0.2)", color: "var(--navy)" };
const EMAIL_STATUSES = ["Parent Approval", "Printing", "Shipped"];

export const BookOrderCard = ({ order, auth, fmtDate, onChange }) => {
  const [notes, setNotes] = useState(order.owner_notes || "");
  const tid = order.id;

  const update = async (patch, msg) => {
    try {
      const { data } = await api.patch(`/admin/book-inquiries/${order.id}`, patch, auth);
      onChange(data);
      toast.success(msg);
      if (data.email_sent === true) toast.success(`Update email sent to ${data.email}`);
      if (data.email_sent === false) toast.error(`Status saved, but the email to ${data.email} could not be delivered.`);
    } catch {
      toast.error("Could not save. Please try again.");
    }
  };

  return (
    <div className="rounded-2xl bg-white border p-6 grid lg:grid-cols-[1.3fr_1fr] gap-6" style={{ borderColor: "rgba(212,175,55,0.3)" }} data-testid={`book-order-${tid}`}>
      <div className="font-body text-sm space-y-1" style={{ color: "var(--navy)" }}>
        <p className="font-display text-2xl">{order.child_first_name} {order.is_gift && <span className="ml-1 align-middle inline-block px-2.5 py-0.5 rounded-full font-body text-xs" style={{ backgroundColor: "rgba(212,175,55,0.18)", color: "var(--navy)" }} data-testid={`book-gift-badge-${tid}`}>Gift</span>}{order.source === "Lesson booking" && <span className="ml-1 align-middle inline-block px-2.5 py-0.5 rounded-full font-body text-xs" style={{ backgroundColor: "rgba(43,168,160,0.15)", color: "var(--navy)" }} data-testid={`book-bundle-badge-${tid}`}>Added at lesson booking</span>} <span className="font-body text-xs" style={{ color: "var(--muted)" }}>· {fmtDate(order.created_at)}</span></p>
        <p>{order.is_gift && <span style={{ color: "var(--muted)" }}>From: </span>}<strong>{order.parent_name}</strong> · {order.email} · {order.phone}</p>
        {order.is_gift && <p><span style={{ color: "var(--muted)" }}>Child's parent:</span> <strong>{order.recipient_parent_name}</strong> · {order.recipient_parent_contact}</p>}
        {order.is_gift && order.gift_message && <p><span style={{ color: "var(--muted)" }}>Gift message:</span> “{order.gift_message}”</p>}
        {order.dedication && <p data-testid={`book-dedication-${tid}`}><span style={{ color: "var(--muted)" }}>Dedication:</span> “{order.dedication}”</p>}
        {order.milestone && <p><span style={{ color: "var(--muted)" }}>Milestone:</span> {order.milestone}</p>}
        {order.special_requests && <p><span style={{ color: "var(--muted)" }}>Requests:</span> {order.special_requests}</p>}
        <p className="text-xs pt-1" style={{ color: "var(--muted)" }}>{order.is_gift ? "Gift giver agreed you'll get written photo consent from the child's parent." : "Parent agreed to the private photo-consent step on the form."}</p>
      </div>
      <div className="space-y-3">
        <select value={order.status} onChange={(e) => update({ status: e.target.value }, `Marked "${e.target.value}"`)}
          className="w-full rounded-lg bg-white px-3 py-2 font-body text-sm border" style={fieldStyle} data-testid={`book-status-${tid}`}>
          {BOOK_STATUSES.map((s) => <option key={s} value={s}>{s}{EMAIL_STATUSES.includes(s) ? " (emails parent)" : ""}</option>)}
        </select>
        <p className="font-body text-xs" style={{ color: "var(--muted)" }} data-testid={`book-emails-${tid}`}>
          Parent is emailed automatically at Parent Approval, Printing &amp; Shipped.
          {order.emails_sent?.length ? ` Sent: ${order.emails_sent.join(", ")}.` : ""}
        </p>
        <label className="flex items-center gap-2 font-body text-sm cursor-pointer" style={{ color: "var(--navy)" }}>
          <input type="checkbox" checked={!!order.photo_consent_received} className="w-4 h-4 accent-[var(--navy)]" data-testid={`book-consent-${tid}`}
            onChange={(e) => update({ photo_consent_received: e.target.checked }, e.target.checked ? "Written photo consent recorded" : "Photo consent unmarked")} />
          Written photo consent received
        </label>
        <textarea rows={2} placeholder="Private notes (Zelle confirmation, Lulu order #…)" value={notes} onChange={(e) => setNotes(e.target.value)}
          onBlur={() => notes !== (order.owner_notes || "") && update({ owner_notes: notes }, "Notes saved")}
          className="w-full rounded-lg bg-white px-3 py-2 font-body text-sm border outline-none" style={fieldStyle} data-testid={`book-notes-${tid}`} />
      </div>
    </div>
  );
};
